export const FILTER_SERVER_MAPPER_DASHBOARD = {
  gestoraId: 'gestoraId'
};
